import {Component, OnInit} from "@angular/core";
import {HttpService} from "../../../_service/http.service";
import {ActivatedRoute, Router} from "@angular/router";
import {isNullOrUndefined} from "util";

@Component({
  templateUrl: './hash-check.component.html',
})
export class HashCheckComponent implements OnInit {


  public checkResult: boolean = null;
  public orgAlias;

  constructor(private httpService: HttpService,
              private router: Router,
              private route: ActivatedRoute) {
  }

  ngOnInit(): void {

    this.orgAlias = localStorage.getItem('organizationAlias');

    if (!isNullOrUndefined(this.route.snapshot.params.hash)) {
      const sb = [];
      sb.push('/rest/confirmEmailHash');
      sb.push('?hash=');
      sb.push(this.route.snapshot.params.hash);
      sb.push('&user=');
      sb.push(this.route.snapshot.params.user);
      sb.push('&orgAlias=');
      sb.push(this.orgAlias);

      this.httpService.getData(sb.join(''))
        .then((data) => {
          this.checkResult = true;

          let isMobile = false;
          if (/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent) ) {
            isMobile = true;
          }


          if (!isMobile) {
            setTimeout(() => {
                this.router.navigate(['/' + this.orgAlias + '/home']);
              },
              1000);
          }
        }, error => {
          this.checkResult = false;
        });

    }
  }

}



// WEBPACK FOOTER //
// D:/dev/smartcityspace_git/web/frontend/src/main/frontend/src/app/main-page/setting-part/hash-check/hash-check.component.ts